/**
 * Shared date/time constants used across settings, scheduling, and team management.
 */

// ---------------------------------------------------------------------------
// Days of week
// ---------------------------------------------------------------------------

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

/** Day-of-week options for select/checkbox UIs (0=Sun, 6=Sat) */
export const DAY_OPTIONS = DAY_LABELS.map((label, value) => ({ value, label }));

// ---------------------------------------------------------------------------
// IANA Timezones (~44 common timezones grouped by region)
// ---------------------------------------------------------------------------

export const TIMEZONE_OPTIONS = [
  // Americas
  { value: 'America/New_York', label: 'Americas - New York (Eastern)' },
  { value: 'America/Chicago', label: 'Americas - Chicago (Central)' },
  { value: 'America/Denver', label: 'Americas - Denver (Mountain)' },
  { value: 'America/Los_Angeles', label: 'Americas - Los Angeles (Pacific)' },
  { value: 'America/Phoenix', label: 'Americas - Phoenix (Arizona)' },
  { value: 'America/Anchorage', label: 'Americas - Anchorage (Alaska)' },
  { value: 'Pacific/Honolulu', label: 'Americas - Honolulu (Hawaii)' },
  { value: 'America/Toronto', label: 'Americas - Toronto' },
  { value: 'America/Vancouver', label: 'Americas - Vancouver' },
  { value: 'America/Mexico_City', label: 'Americas - Mexico City' },
  { value: 'America/Bogota', label: 'Americas - Bogota' },
  { value: 'America/Sao_Paulo', label: 'Americas - Sao Paulo' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Americas - Buenos Aires' },
  { value: 'America/Santiago', label: 'Americas - Santiago' },
  // Europe
  { value: 'Europe/London', label: 'Europe - London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Europe - Paris (CET)' },
  { value: 'Europe/Berlin', label: 'Europe - Berlin (CET)' },
  { value: 'Europe/Madrid', label: 'Europe - Madrid (CET)' },
  { value: 'Europe/Rome', label: 'Europe - Rome (CET)' },
  { value: 'Europe/Amsterdam', label: 'Europe - Amsterdam (CET)' },
  { value: 'Europe/Zurich', label: 'Europe - Zurich (CET)' },
  { value: 'Europe/Vienna', label: 'Europe - Vienna (CET)' },
  { value: 'Europe/Athens', label: 'Europe - Athens (EET)' },
  { value: 'Europe/Istanbul', label: 'Europe - Istanbul (TRT)' },
  { value: 'Europe/Moscow', label: 'Europe - Moscow (MSK)' },
  // Asia & Pacific
  { value: 'Asia/Dubai', label: 'Asia - Dubai (GST)' },
  { value: 'Asia/Kolkata', label: 'Asia - Kolkata (IST)' },
  { value: 'Asia/Bangkok', label: 'Asia - Bangkok (ICT)' },
  { value: 'Asia/Singapore', label: 'Asia - Singapore (SGT)' },
  { value: 'Asia/Hong_Kong', label: 'Asia - Hong Kong (HKT)' },
  { value: 'Asia/Shanghai', label: 'Asia - Shanghai (CST)' },
  { value: 'Asia/Tokyo', label: 'Asia - Tokyo (JST)' },
  { value: 'Asia/Seoul', label: 'Asia - Seoul (KST)' },
  { value: 'Asia/Jakarta', label: 'Asia - Jakarta (WIB)' },
  { value: 'Australia/Sydney', label: 'Pacific - Sydney (AEST)' },
  { value: 'Australia/Melbourne', label: 'Pacific - Melbourne (AEST)' },
  { value: 'Australia/Perth', label: 'Pacific - Perth (AWST)' },
  { value: 'Pacific/Auckland', label: 'Pacific - Auckland (NZST)' },
  { value: 'Pacific/Fiji', label: 'Pacific - Fiji' },
  // Africa
  { value: 'Africa/Cairo', label: 'Africa - Cairo (EET)' },
  { value: 'Africa/Johannesburg', label: 'Africa - Johannesburg (SAST)' },
  { value: 'Africa/Lagos', label: 'Africa - Lagos (WAT)' },
  { value: 'Africa/Nairobi', label: 'Africa - Nairobi (EAT)' },
  { value: 'Africa/Casablanca', label: 'Africa - Casablanca (WET)' },
];
